<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/equipment/check/bill/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('dianjiandanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_cross_select :max="1" :component="'web_base_equipment_list'" :ids.sync="yt.conditions.equipmentId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('dianjianzhuangtai')">
            <yi_dictionary_select :type="'EQUIPMENT_CHECK_STATUS'" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('dianjianjieguo')">
            <yi_dictionary_select :type="'EQUIPMENT_CHECK_RESULT'" :ids.sync="yt.conditions.result"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jihuadianjianshijian')">
            <yi_time_input type="datetime" value-format="timestamp" :time.sync="yt.conditions.planTime"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('dianjianxiang', scope.row, '70%')" v-if="utils.checkPower('web_equipment_check_item_page')">
              {{ $t('dianjianxiang') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="scope.row.status == 1 && utils.checkPower('web_equipment_check_delete')" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/equipment/check/bill/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 点检项 -->
      <template v-if="yt.editObj.action == 'dianjianxiang'">
        <div class="dialog-scroller">
          <check_item :equipment="yt.editObj" ref="checkItem"></check_item>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini" @click="submitCheckItem(yt.editObj)" type="primary" :loading="yt.editObj.loading" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '设备点检-提交点检' } }">
            {{ $t('tijiao') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import check_item from '@@/pages/web/equipment/check/check_item';
export default {
  name: 'web_equipment_check_list',
  components: {
    check_item
  },

  data() {
    return {
      leaveFactoryDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      list: [],
      columns: [
        {
          label: 'dianjiandanhao',
          prop: 'no'
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name'
        },
        {
          label: 'dianjianzhuangtai',
          prop: 'status',
          type: 'dictionary_tag',
          key: 'EQUIPMENT_CHECK_STATUS'
        },
        {
          label: 'jihuadianjianshijian',
          prop: 'planTime',
          type: 'time'
          // format: 'yyyy-MM-dd:hh:mm:ss'
        },
        {
          label: 'dianjianjieguo',
          prop: 'result',
          type: 'dictionary_tag',
          key: 'EQUIPMENT_CHECK_RESULT'
        },
        {
          label: 'dianjianren',
          prop: 'checkUser.nickname'
        },
        {
          label: 'dianjianshijian',
          prop: 'checkTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.get(1);
      this.getEquipmentName();
    }, 300);
  },

  methods: {
    submitCheckItem(value) {
      this.yt.editObj.loading = true;
      this.http
        .post('web/equipment/check/bill/commit', {
          id: value.id,
          remark: value.remark,
          itemList: this.$refs.checkItem.$refs.yt.list
        })
        .then(res => {
          this.yt.isShowEditDialog = false;
          this.yt.get(1);
        })
        .catch(e => {
          this.$message.error(this.$t(e));
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    }
  }
};
</script>
